import React from 'react';
import Navbar from './Navbar';
import MysticalParticles from './MysticalParticles';
import { MessageSquare } from 'lucide-react';

const Forum = () => {

  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Magical Background */}
      <div className="fixed inset-0 -z-10">
        <img 
          src="https://cdn.4fingerstudios.com/Mystveil/Mystveil_map.png" 
          alt="Mystveil Township Map" 
          className="w-full h-full object-cover opacity-30 blur-sm" 
        />
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-pink-900/20 to-purple-900/20"></div>
      </div>

      {/* Magical Particles */}
      <MysticalParticles />

      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main className="flex-grow px-4 py-8">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="mystical-card mb-8">
            <div className="flex items-center space-x-3 mb-6">
              <MessageSquare className="text-purple-600" size={32} />
              <h1 className="mystical-title text-black">Mystveil Community Forum</h1>
            </div>
            
            <p className="mystical-text text-gray-600">
              Forum coming soon! Stay tuned for community discussions.
            </p>
          </div>

          {/* Coming Soon Content */}
          <div className="mystical-card">
            <div className="text-center py-16">
              <MessageSquare className="text-gray-400 mx-auto mb-6" size={64} />
              <h2 className="mystical-subtitle text-black text-2xl mb-4">Forum Under Construction</h2>
              <p className="mystical-text text-gray-600 mb-8">
                We're working hard to bring you an amazing community forum experience.
              </p>
              <div className="mystical-card bg-white bg-opacity-95 max-w-md mx-auto">
                <p className="mystical-text text-gray-700">
                  Features coming soon:
                </p>
                <ul className="mystical-text text-gray-600 text-sm mt-3 space-y-1">
                  <li>• Community discussions</li>
                  <li>• Character showcases</li>
                  <li>• Help & support</li>
                  <li>• Events & contests</li>
                  <li>• Trading & sales</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Mystical Footer */}
      <footer className="mystical-nav py-6 mt-auto">
        <div className="container mx-auto px-4 text-center">
          <p className="mystical-text font-bold">
            © 2024 4fingerstudios <br /> 
            © 2024 Reckless Dreams. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Forum;
